export default {
  getIsNavOpen: (state) => state.isNavOpen,
  getIsMobileDensity: (state) => state.isMobileDensity,
  getUserSitemap: function(state) {
    return state.sitemap;
  },
};
